import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SafeModule } from 'src/app/@core/pipes/pipe-modules/safe.module';
import { MaterialCtaFormWithMapComponent } from './cta-form-with-map.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSliderModule } from '@angular/material/slider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MaterialCtaFormModule } from '../cta-form/cta-form.module';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    MaterialCtaFormWithMapComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatSliderModule,
    MatCheckboxModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    FormsModule,
    SafeModule.forRoot(),
    ReactiveFormsModule,
    FlexLayoutModule,
    MatButtonModule,
    MaterialCtaFormModule
  ],
  exports: [MaterialCtaFormWithMapComponent]
})
export class MaterialCtaFormWithMapModule { }